import { ProjectNanoID } from '../projects/projectsTypes';
import { ProjectsTaskNanoID } from './projectsTasksTypes';

export class ProjectsTaskCache {
  static indexCacheKey() {
    return 'projects-tasks';
  }

  static showCacheKey() {
    return 'projects-task';
  }

  static showCoefficientCacheKey() {
    return 'projects-task-coefficient';
  }

  static showProjectTreeCacheKey() {
    return 'project-projects-tasks-tree';
  }

  static showProjectTreeRootCacheKey() {
    return 'project-tree-root';
  }

  static showProjectsTaskBreadcrumbsCacheKey() {
    return 'projects-task-breadcrumbs';
  }

  static showParentProjectsCacheKey(nanoId: ProjectNanoID) {
    return `projects-task-${nanoId}-parents-projects`;
  }

  static showRootProjectCacheKey(nanoId: ProjectsTaskNanoID) {
    return `projects-task-${nanoId}-root-project`;
  }

  static showMembersCacheKey(nanoId: ProjectsTaskNanoID) {
    return `projects-task-${nanoId}-members`;
  }

  static showChildProjectsTasksCacheKey(nanoId: ProjectNanoID) {
    return `project-${nanoId}-child-projects-tasks`;
  }

  static showChildProjectsCacheKey(nanoId: ProjectNanoID) {
    return `project-${nanoId}-child-projects`;
  }
}
